import { render, staticRenderFns } from "./OrderingSubjectList.vue?vue&type=template&id=6d70f406&scoped=true&"
import script from "./OrderingSubjectList.vue?vue&type=script&lang=ts&"
export * from "./OrderingSubjectList.vue?vue&type=script&lang=ts&"
import style0 from "./OrderingSubjectList.vue?vue&type=style&index=0&id=6d70f406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70f406",
  null
  
)

export default component.exports